// Traditional Chinese — full mirror of the English baseline, translated
// for the primary Forwaro Taiwan / Hong Kong audience.

const common = {
  // Navigation
  "nav.home": "首頁",
  "nav.products": "產品",
  "nav.factory": "工廠",
  "nav.about": "關於我們",
  "nav.contact": "聯絡我們",
  "nav.requestQuote": "詢價報價",
  "nav.menu": "選單",
  "nav.language": "語言",

  // CTAs
  "cta.requestQuote": "立即詢價",
  "cta.exploreCatalog": "瀏覽型錄",
  "cta.contactUs": "聯絡我們",
  "cta.scheduleFactoryVisit": "預約參訪工廠",
  "cta.requestSample": "索取樣品",
  "cta.viewAll": "瀏覽所有產品",

  // Common terms
  "common.tbd": "[待 Forwaro 確認]",
  "common.category": "分類",
  "common.material": "材質",
  "common.style": "風格",
  "common.filters": "篩選",
  "common.resetAll": "重設",
  "common.details": "詳情",

  // Brand
  "brand.name": "風華國際",
  "brand.chineseName": "風華國際",
  "brand.tagline": "FORWARO FURNITURE · 風華國際 · 現代傢俱",

  "whatsapp.cta": "在 WhatsApp 聯絡我們",
  "wechat.cta": "加我們的微信",


  // Home · Hero
  "home.hero.badge": "FORWARO · 風華國際 · 現代傢俱",
  "home.hero.headline.line1": "家，是忙碌生活中",
  "home.hero.headline.line2Highlight": "一切的中心。",
  "home.hero.headline.line3": "",
  "home.hero.subheadline": "Forwaro Furniture 風華國際 是一家位於東莞的 OEM / ODM 製造商，以傢俱設計搭配穩定的生產品質，服務中東、歐洲、美洲與亞洲的進口商。",
  "home.hero.stat1.value": "6",
  "home.hero.stat1.label": "產品線",
  "home.hero.stat2.value": "OEM / ODM",
  "home.hero.stat2.label": "客製化生產",
  "home.hero.stat3.value": "東莞",
  "home.hero.stat3.label": "民田工業區",
  "home.hero.stat4.value": "全球",
  "home.hero.stat4.label": "外銷合作網絡",
  "home.hero.scroll": "下拉",

  // Home · Categories
  "home.categories.kicker": "產品分類",
  "home.categories.heading": "六大產品線，一家值得信賴的工廠",
  "home.categories.description": "餐桌、茶几、玄關桌、椅子、沙發與電視櫃：Forwaro 專為出口生產的六大 B2B 傢俱產品線。",

  // Home · About
  "home.about.kicker": "關於 Forwaro",
  "home.about.heading.line1": "家具設計，",
  "home.about.heading.line2": "一貫的工藝堅持。",
  "home.about.philosophy.en":
    "在日益繁忙的生活裡，家是一切的中心。生活美學相對成為成功人士對家的追求與品味。風華國際秉持一貫對家具的設計理念，與生產品質的堅持，希望為所有的家，提升至美學與工藝相輔的層次空間。",
  "home.about.location": "Forwaro Furniture（風華國際有限公司）1991 年創立於台灣，2006 年起於中國大陸設廠製造，目前營運據點位於東莞沙田鎮民田工業區。Forwaro 與重視誠實工藝、可靠交期的進口商並肩合作。",
  "home.about.highlight1.title": "OEM 與 ODM",
  "home.about.highlight1.body": "從自有品牌代工到完整設計與結構客製化，皆可配合。",
  "home.about.highlight2.title": "出口級品管",
  "home.about.highlight2.body": "木工、表面處理、包裝逐站檢查，並考量長程海運的耐運表現。",
  "home.about.highlight3.title": "天然大理石與鋼材",
  "home.about.highlight3.body": "招牌天然大理石桌面，搭配電鍍不鏽鋼與鐵製底座。",
  "home.about.highlight4.title": "全球外銷網絡",
  "home.about.highlight4.body": "自東莞出發，服務中東、歐洲、美洲與亞洲的進口商。",
  "home.about.badgeLocation": "中國・東莞",
  "home.about.badgeZone": "民田工業區",
  "home.about.badgeOem": "OEM /\nODM",
  "home.about.badgeOemSub": "客製化與自有品牌",

  // Home · Featured Products
  "home.featured.kicker": "型錄預覽",
  "home.featured.heading": "搶先預覽 Forwaro 六大產品線",
  "home.featured.description": "真實的 Forwaro 型號，材質與尺寸皆經確認。歡迎聯絡我們索取完整規格與報價。",

  // Home · Markets
  "home.markets.kicker": "全球版圖",
  "home.markets.heading": "我們服務的外銷市場",
  "home.markets.description":
    "Forwaro 與四大洲的家具進口商、經銷商、飯店集團與住宅專案合作。",

  // Home · Process
  "home.process.heading": "合作流程",
  "home.process.description": "從第一次詢價到櫃上船——Forwaro 標準外銷流程",

  // Footer
  "footer.getInTouch.kicker": "聯繫我們",
  "footer.getInTouch.heading": "與 Forwaro 一起\n展開家具外銷合作",
  "footer.getInTouch.description":
    "我們的外銷團隊可為您提供客製報價、樣品寄送與完整外銷文件支援。",
  "footer.contact.email": "電子郵件",
  "footer.contact.phone": "電話",
  "footer.contact.fax": "傳真",
  "footer.contact.factory": "工廠",
  "footer.contact.whatsappNote": "WhatsApp / WeChat 帳號待 Forwaro 確認後補上。",
  "footer.form.heading": "立即詢價",
  "footer.form.name": "姓名",
  "footer.form.email": "電子郵件",
  "footer.form.company": "公司",
  "footer.form.country": "國家",
  "footer.form.countryPlaceholder": "請選擇國家",
  "footer.form.message": "留言",
  "footer.form.messagePlaceholder": "請告訴我們您的需求、預計數量與目標市場…",
  "footer.form.submit": "送出詢價",
  "footer.form.sending": "送出中…",
  "footer.form.success.heading": "已送出！",
  "footer.form.success.body": "外銷團隊將於兩個工作日內與您聯繫。",
  "footer.form.sendAnother": "再送一次",
  "footer.footerTagline": "Forwaro Furniture · 風華國際 · 現代傢俱。位於東莞的 OEM/ODM 製造商，服務中東、歐洲、美洲與亞洲的進口商。",
  "footer.col.products": "產品",
  "footer.col.company": "公司",
  "footer.col.markets": "外銷市場",
  "footer.col.regional": "想成為區域經銷商？",
  "footer.copyright": "版權所有。",
};

export default common;
